window["define"](function (require) {
    //#region Dépendances du module
    var $ = require("jquery");
    var DataTable = require("datatables.net");
    require("datatables.bootstrap");
    var renders = require("datatables.render.methods");
    require('dataTables.fixedHeader.min');
    //Pour que DataTables.net throw les erreurs dans la console au lieu d'un alert()
    $.fn.dataTable.ext.errMode = 'throw';
    var quantatree2 = require("quantatree2");
    var i18n = require("i18n");
    //#endregion
    $(function onDomReady() {
        var bIsSectionVisible = $('#documents').length && $('.treeTypes').length;
        if (!bIsSectionVisible) {
            return;
        }
        var cols = [
            { name: "sDocType", orderable: true, title: i18n.sType, visible: true, createdCell: renders.createdCellReturn, className: "text-left", type: "string" },
            { name: "sDocType_Code", visible: false, type: "string" },
            { name: "sPays", orderable: false, title: i18n.sPays, visible: true, createdCell: renders.createdCellReturn, className: "text-left", type: "string" },
            { name: "sPays_Code", visible: false, type: "string" },
            { name: "sLangue", orderable: true, title: i18n.sLangue, visible: true, createdCell: renders.createdCellReturn, className: "text-left", type: "string" },
            { name: "sLangue_Code", visible: false, type: "string" },
            { name: "dtPublication", orderable: true, title: i18n.dtPublication, visible: true, render: renders.renderDate, type: "string" },
            { name: "sURL", visible: true, orderable: false, render: renders.renderImgPDF },
        ];
        //applique un attribut col.data =  col.name sur toute les colonnes
        cols.forEach(function (x) { return x['data'] = x['data'] || x.name; });
        initialize_trees();
        var data = JSON.parse($("#DataDocuments").val());
        var tableApi = $('.qt-search-table').DataTable({
            columns: cols,
            data: data,
            autoWidth: true,
            lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
            pagingType: "numbers",
            pageLength: 25,
            processing: true,
            serverSide: false,
            dom: "<tr><'dataTableFooter'pil><'clearfix'>",
            language: _getLanguageOptionsDataTable(i18n),
            order: [[2, "asc"]],
            search: {
                'regex': false,
            }
        });
        // Initialise les arbres des filtres
        function initialize_trees() {
            var treeSpecs = [
                {
                    $dom: $(".treePays"),
                    title: i18n.sPays,
                    filterCol: "sPays_Code"
                },
                {
                    $dom: $(".treeTypes"),
                    title: i18n.sType,
                    filterCol: "sDocType_Code"
                },
                {
                    $dom: $(".treeLangues"),
                    title: i18n.sLangue,
                    filterCol: "sLangue_Code"
                },
            ];
            for (var i = 0; i < treeSpecs.length; i++) {
                var tree = treeSpecs[i];
                tree.$dom.attr('data-filter', tree.filterCol);
                tree.$dom.quantatree2({
                    allSelectedText: tree.title,
                    displayCheckboxAll: false,
                    displayFilter: false,
                });
                tree.$dom.on('click', function (e) {
                    var $treeDom = $(e.currentTarget);
                    applyFilter($treeDom);
                });
            }
        }
        /**
         * Applique un filtre recherche sous la forme de RegExp pour trouver plusieurs valeurs
         * @param $treeDom balise div de l'arbre concerné
         */
        function applyFilter($treeDom) {
            var sfilterName = $treeDom.attr('data-filter');
            var keys = $treeDom.quantatree2("getSelectedKeys");
            if (keys.length > 0) {
                var regExp = '(' + escapeSpecialCaracters(keys.join('|')) + ')';
                tableApi.column(sfilterName + ":name").search(regExp, true, false).draw();
            }
            else {
                tableApi.column(sfilterName + ":name").search('').draw();
            }
        }
        function _getLanguageOptionsDataTable(i18n) {
            return {
                "sProcessing": i18n.sProcessing,
                "sSearch": i18n.sSearch,
                "sLengthMenu": i18n.sLengthMenu,
                "sInfo": i18n.sInfo,
                "sInfoEmpty": i18n.sInfoEmpty,
                "sInfoFiltered": i18n.sInfoFiltered,
                "sInfoPostFix": i18n.sInfoPostFix,
                "sLoadingRecords": i18n.sLoadingRecords,
                "sZeroRecords": i18n.sZeroRecords,
                "sEmptyTable": i18n.sEmptyTable,
                "oPaginate": {
                    "sFirst": i18n["oPaginate.sFirst"],
                    "sPrevious": i18n["oPaginate.sPrevious"],
                    "sNext": i18n["oPaginate.sNext"],
                    "sLast": i18n["oPaginate.sLast"]
                },
                "oAria": {
                    "sSortAscending": i18n["oAria.sSortAscending"],
                    "sSortDescending": i18n["oAria.sSortDescending"]
                }
            };
        }
        /**
         * échape les caractères spécieux pour les regexp
         * @param sInput String d'entrée
         */
        function escapeSpecialCaracters(sInput) {
            return sInput.replace(/[()]/g, '\\$&');
        }
    });
});
//# sourceMappingURL=Documents.js.map